<template lang="pug">
    .card-payment(v-if="content")
      h3.card-payment__title(v-if='content.subtitle1') {{ content.subtitle1 }}
      .card-payment__text(v-if='content.text1' v-html="content.text1")
      ul.card-payment__cards(v-if='content.cardList')
        li.card-payment__cards-item(v-for="(item, index) in content.cardList" :key="index") {{ item.cardName }}
      h4.card-payment__subtitle(v-if='content.headline1') {{ content.headline1 }}
      .card-payment__text(v-if='content.text2' v-html="content.text2")
      h4.card-payment__subtitle(v-if='content.headline2') {{ content.headline2 }}
      .card-payment__text(v-if='content.text3' v-html="content.text3")
      h4.card-payment__subtitle(v-if='content.headline3')  {{ content.headline3 }}
      .card-payment__text(v-if='content.text4' v-html="content.text4")
      h3.card-payment__title(v-if='content.subtitle2')  {{ content.subtitle2 }}
      .card-payment__text(v-if='content.text5' v-html="content.text5")
      h3.card-payment__title(v-if='content.headline3')  {{ content.subtitle3 }}
      .card-payment__text(v-if='content.text6' v-html="content.text6")
      h4.card-payment__subtitle(v-if='content.headline4')  {{ content.headline4 }}
      h4.card-payment__subtitle(v-if='content.headline5')  {{ content.headline5 }}
      img.card-payment__img-card(v-if='content.visaCards.path' :src="content.visaCards.path" :alt="content.visaCards.name")
      .card-payment__text(v-if='content.text7' v-html="content.text7")
      h4.card-payment__subtitle(v-if='content.headline6') {{ content.headline6 }}
      .card-payment__text(v-if='content.text8' v-html="content.text8")
      img.card-payment__img-card(v-if='content.masterCards.path' :src="content.masterCards.path" :alt="content.masterCards.name")
      h4.card-payment__subtitle(v-if='content.headline7') {{ content.headline7}}
      ol.card-payment__list(v-if='content.textList')
        li.card-payment__list-item(v-for="(item, index) in content.textList" :key="index") {{ item.text }}
      img.card-payment__card(v-if='content.cardImage.path' :src="content.cardImage.path" :alt="content.cardImage.name")
      .card-payment__text(v-if='content.text9' v-html="content.text9")
      h3.card-payment__title(v-if='content.sibtitle4') {{ content.subtitle4 }}
      img.card-payment__logo-bank(v-if='content.bankLogo.path' :src="content.bankLogo.path" :alt="content.bankLogo.name")
      .card-payment__text(v-if='content.text10' v-html="content.text10")
      h3.card-payment__title(v-if='content.sibtitle5') {{ content.subtitle5 }}
      h4.card-payment__subtitle(v-if='content.headline8') {{ content.headline8}}
      .card-payment__text(v-if='content.text11' v-html="content.text11")
      .card-payment__block(v-if='content.verifiedCards')
        img.card-payment__block-image(v-for="item in content.verifiedCards" :src="item.path" :alt="item.name")
      .card-payment__text(v-if='content.text12' v-html="content.text12")
      h4.card-payment__subtitle(v-if='content.headline9') {{ content.headline9}}
      .card-payment__text(v-if='content.text13' v-html="content.text13")
</template>

<script>
    import EventBus from '@/eventBus';

    import '@/components/cardPayment/cardPayment.styl';
    import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
    import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

    // @ is an alias to /src
    //import Footer from '@/components/common/footer/Footer.vue';

    export default {
        name: 'CardPayment',

        mixins: [AjaxHelpersVue],

        data() {
            return {
                content: null,
            }
        },

        components: {
            //Footer
        },

        created() {
            // Загрузка данных для страницы
            EventBus.$on('loadCardPaymentPage', (params) => {
                this.request(params.url);
                $('.header__nav-item').removeClass('header__nav-item--active');
            });

            EventBus.$on('scrollbarInit', scrollbar => {
                this.scrollbar = scrollbar;
                let elem = document.querySelector('.page__view');
                elem.addEventListener('ps-scroll-down', () =>  {
                    $('.page__decore--12').addClass('page__decore--hide-bottom');
                    $('.page__decore--11').addClass('page__decore--hide-bottom');
                    $('.page__decore--10').addClass('page__decore--hide-bottom');
                    if(this.scrollbar.reach.y === "end") {
                        $('.samedia').removeClass('samedia--hide');
                        $('.footer').removeClass('footer--hide');
                        $('.page__decore--12').removeClass('page__decore--hide-bottom');
                        $('.page__decore--11').removeClass('page__decore--hide-bottom');
                        $('.page__decore--10').removeClass('page__decore--hide-bottom');
                    }
                });
                elem.addEventListener('ps-scroll-up', () =>  {
                    $('.samedia').addClass('samedia--hide');
                    $('.footer').addClass('footer--hide');
                    $('.page__decore--12').addClass('page__decore--hide-bottom');
                    $('.page__decore--11').addClass('page__decore--hide-bottom');
                    $('.page__decore--10').addClass('page__decore--hide-bottom');
                });
            });
        },

        methods: {
            request(url) {
                // Нейминг должен быть такой, без цифр в начале
                this.req('CardPaymentPage:getCardPaymentPage', {url: url}, res => {
                    EventBus.$emit('pagePreloaderHide');
                    if(this.checkProperty(res.content)) {
                        this.content = res.content;
                        this.$nextTick(() => {
                            $('.page__decore--12').addClass('page__decore--hide-bottom');
                            $('.page__decore--11').addClass('page__decore--hide-bottom');
                            $('.page__decore--10').addClass('page__decore--hide-bottom');
                        });
                    }
                }, 'card-payment');
            }
        }
    }
</script>
